<template>
    <div class="policiesSearch">
        <Row :gutter="4">
            <Col span="4">
                <Input search v-model="policiesSearchKey" :placeholder="$t('patch_management.patch_policy.queryByPolicyName')" @on-search="searchPolicies()" />
            </Col>
            <Col span="16">
                <add-policies></add-policies>
            </Col>
        </Row>
    </div>
</template>
<script>
    import AddPolicies from '../policy/AddPolicies'
    import TablePolicies from '../policy/TablePolicies'
    var tablePolicies=TablePolicies;
    export default {
        name: 'PoliciesSearch',
        components: {
            AddPolicies
        },
        data () {
            return {
                policiesSearchKey:'',
                schedulePoliciesName:''
            }
        },
        methods:{
            searchPolicies(){
                // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
                eventBus.$emit('schedulePoliciesName', this.policiesSearchKey);
                tablePolicies.methods.showAll();
            }
        }
    }
</script>
<style scoped>
    .policiesSearch
    {
        padding: 4px 0px 15px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/patch_management/policy/PoliciesSearch.vue